export function getRandomDelayMs() {
  // This yields an integer from 3..5
  const seconds = Math.floor(Math.random() * (5 - 3 + 1)) + 3;
  return seconds * 1000;
}
